import React, { useState } from "react";
import { WithDefaultLayout } from "../components/DefautLayout";
import { workshop_programData } from "@/constants";
import { Title } from "../components/Title";
import { certificates } from "../constants/Certificates";
import { program } from "@/interfaces/Workshop";

const CertificatePage = () => {
  const [activeTab, setActiveTab] = useState<string>("BNSP");
  const [activeSubTab, setActiveSubTab] = useState<string | null>("Semua");
  const [searchNumber, setSearchNumber] = useState("");
  const [searchName, setSearchName] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const bnspPrograms: program[] =
    workshop_programData["Paket Uji Bersertifikasi BNSP"]?.["__DIRECT__"] ?? [];

  const bnspSubTabs = Array.from(
    new Set(bnspPrograms.map((p) => p.shortTitle))
  );

  const dynamicBootcampTabs = Array.from(
    new Set(certificates.filter((cert) => cert.type === "Bootcamp").map((cert) => cert.scheme))
  );

  const subTabs: Record<string, string[]> = {
    BNSP: ["Semua", ...bnspSubTabs],
    Bootcamp: ["Semua", ...dynamicBootcampTabs],
  };

  const filteredData = certificates.filter((cert) => {
    if (cert.type !== activeTab) return false;
    if (
      activeSubTab &&
      activeSubTab !== "Semua" &&
      cert.category !== activeSubTab
    )
      return false;
    return (
      cert.number.toLowerCase().includes(searchNumber.toLowerCase()) &&
      cert.name.toLowerCase().includes(searchName.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + entriesPerPage
  );

  React.useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, activeSubTab, searchNumber, searchName, entriesPerPage]);

  const maxVisible = 5;
  const groupIndex = Math.floor((currentPage - 1) / maxVisible);
  const dynamicStart = groupIndex * maxVisible + 1;
  const dynamicEnd = Math.min(dynamicStart + maxVisible - 1, totalPages);
  const pageNumbers: number[] = [];
  for (let i = dynamicStart; i <= dynamicEnd; i++) {
    pageNumbers.push(i);
  }
  return (
    <section className="relative bg-gradient-to-b from-[#B3E5FC] to-white overflow-hidden">
      <img
        src="/img/course/ornaments/book.png"
        alt="book"
        className="absolute hidden lg:block top-[80px] left-[200px] w-[120px]"
      />
      <img
        src="/img/lms/Medali.png"
        alt="medali"
        className="absolute hidden lg:block top-[80px] right-[200px] w-[120px]"
      />
      <div className="w-full max-w-6xl mx-auto py-8 px-4">
        <Title title={"Certificate"} description="" />
        <h1 className="text-3xl md:text-4xl font-bold font-body text-center text-[#015C92] mb-6">
          Daftar Pemegang Sertifikat
        </h1>

        {/* Tabs Utama */}
        <div className="flex justify-center gap-4 mb-6 flex-wrap font-body">
          {["BNSP", "Bootcamp"].map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setActiveSubTab("Semua");
              }}
              className={`px-4 py-2 rounded font-medium border shadow-sm transition ${activeTab === tab
                ? "bg-[#1E3A8A] text-white border-[#0284C7]"
                : "bg-white text-[#0277BD] border-[#81D4FA] hover:bg-[#2563EB] hover:text-white"
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Sub Tabs */}
        <div className="flex justify-center gap-4 mb-6 flex-wrap font-body">
          {subTabs[activeTab]?.map((sub) => (
            <button
              key={sub}
              onClick={() => setActiveSubTab(sub)}
              className={`px-4 py-2 rounded font-medium border shadow-sm transition ${activeSubTab === sub
                ? "bg-[#1E3A8A] text-white border-[#0284C7]"
                : "bg-white text-[#0277BD] border-[#81D4FA] hover:bg-[#E1F5FE]"
                }`}
            >
              {sub}
            </button>
          ))}
        </div>

        {/* Search Inputs */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 flex flex-col md:flex-row gap-4 justify-between">
          <div className="flex flex-col w-full md:w-1/2">
            <label
              htmlFor="number"
              className="text-gray-700 font-body font-semibold mb-2"
            >
              Nomor Sertifikat
            </label>
            <input
              id="number"
              type="text"
              value={searchNumber}
              onChange={(e) => setSearchNumber(e.target.value)}
              placeholder="Masukkan nomor sertifikat..."
              pattern="[A-Za-z0-9-]+"
              title="Hanya huruf, angka, dan tanda strip (-)"
              className="border border-gray-300 rounded-md font-body p-2 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            />
          </div>

          <div className="flex flex-col w-full md:w-1/2">
            <label
              htmlFor="name"
              className="text-gray-700 font-body font-semibold mb-2"
            >
              Nama Pemegang
            </label>
            <input
              id="name"
              type="text"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              placeholder="Masukkan nama pemegang..."
              className="border border-gray-300 rounded-md font-body p-2 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
          <div className="flex items-center gap-2 text-gray-700 font-body">
            <span>Show</span>
            <select
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
              className="border border-gray-300 rounded-md px-2 py-1 focus:ring-2 focus:ring-teal-500 focus:outline-none"
            >
              {[5, 10, 15, 25].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span>entries</span>
          </div>
        </div>

        {/* Table (Desktop) */}
        <div className="bg-white shadow-lg rounded overflow-hidden">
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full text-sm text-gray-700 border-collapse">
              <thead className="bg-[#1E3A8A] text-white font-body">
                <tr>
                  <th className="px-4 py-3 text-left">Nomor Sertifikat</th>
                  <th className="px-4 py-3 text-left">Nama</th>
                  <th className="px-4 py-3 text-left">Skema Sertifikasi</th>
                  <th className="px-4 py-3 text-center">
                    Tahun Pelaksanaan
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((cert, index) => (
                    <tr
                      key={index}
                      className={`border-b font-body ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                        }`}
                    >
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        {cert.number}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        {cert.name}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        {cert.scheme}
                      </td>
                      <td className="px-4 py-3 font-semibold text-gray-800 text-center">
                        <p className="font-semibold text-gray-800">
                          {/* {new Date(cert.date).toISOString().split("T")[0]} */}
                          {cert.date}
                        </p>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className="text-center text-gray-500 py-5 italic"
                    >
                      Tidak ada data yang cocok.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="block md:hidden p-4">
            {paginatedData.length > 0 ? (
              <div className="grid grid-cols-1 gap-4">
                {paginatedData.map((cert, index) => (
                  <div
                    key={index}
                    className="border-4 border-[#0284C7] rounded-lg shadow-sm p-4 bg-gray-50"
                  >
                    <p className="text-sm text-gray-500 mb-1 font-medium">
                      Nomor Sertifikat
                    </p>
                    <p className="font-semibold text-gray-800">{cert.number}</p>
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-medium">
                      Nama
                    </p>
                    <p className="font-semibold text-gray-800">{cert.name}</p>
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-medium">
                      Skema Sertifikasi
                    </p>
                    <p className="font-semibold text-gray-800">{cert.scheme}</p>
                    <p className="text-sm text-gray-500 mt-2 mb-1 font-medium">
                      Tanggal Uji Sertfikasi
                    </p>
                    <p className="font-semibold text-gray-800">
                      {new Date(cert.date).toISOString().split("T")[0]}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500 italic py-5">
                Tidak ada data yang cocok.
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-6 font-body text-sm text-gray-700">
          <div className="text-gray-600 mb-3 md:mb-0">
            Showing{" "}
            {filteredData.length === 0
              ? 0
              : (currentPage - 1) * entriesPerPage + 1}{" "}
            to {Math.min(currentPage * entriesPerPage, filteredData.length)} of{" "}
            {filteredData.length} entries
          </div>

          {/* Right: Page buttons */}
          <div className="flex items-center space-x-1">
            {/* Previous */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md border text-sm ${currentPage === 1
                ? "text-gray-400 border-gray-300 cursor-not-allowed"
                : "text-teal-700 border-gray-300 hover:bg-teal-100"
                }`}
            >
              Previous
            </button>

            {/* Page numbers - Gunakan array pageNumbers yang sudah kita hitung */}
            {pageNumbers.map((pageNum) => (
              <button
                key={pageNum}
                onClick={() => setCurrentPage(pageNum)}
                className={`px-3 py-1 rounded-md border text-sm ${currentPage === pageNum
                  ? "bg-[#1E3A8A] text-white"
                  : "text-gray-700 border-gray-300 hover:bg-teal-100"
                  }`}
              >
                {pageNum}
              </button>
            ))}

            {/* Tampilkan "..." jika masih ada halaman di depan yang belum muncul */}
            {dynamicEnd < totalPages && <span className="px-2">...</span>}

            {/* Next */}
            <button
              onClick={() => setCurrentPage((prev) => (prev < totalPages ? prev + 1 : totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              className={`px-3 py-1 rounded-md border text-sm ${currentPage === totalPages || totalPages === 0
                ? "text-gray-400 border-gray-300 cursor-not-allowed"
                : "text-teal-700 border-gray-300 hover:bg-teal-100"
                }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

CertificatePage.layout = WithDefaultLayout;
export default CertificatePage;
